import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY
})



// WEBPACK FOOTER //
// ./src/plugins/captcha.js